import { 
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData, 
    addDataFactory
} from "../../core/core";
import { IDashboardSharedViewModel, KeyedDimension, sexes } from "./viewModel";

export { sexes }

/**
 * 
 * @param sex Convert raw sex code to enum
 */
export const toSex = (sex: number): KeyedDimension => {
    if (!sex)
        return sexes.unknown;

    switch (sex) {
        case 3: return sexes.indeterminate;
        case 2: return sexes.female;
        case 9: return sexes.unknown;
        default: return sexes.male;
    }
};

const rank = {
    [sexes.male.name]: 1,
    [sexes.female.name]: 2,
    [sexes.indeterminate.name]: 3,
    [sexes.unknown.name]: 4,
};

/**
 * Sort asc
 * @param a 
 * @param b 
 */
export const sort = (_: ISourceData, a: string, b: string): number => {
    const a1 = rank[a];
    const b1 = rank[b];

    return (a1 > b1) ? -1 : ((a1 < b1 ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export const createData = createCoreData;

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
export const addData = addDataFactory((vm: IDashboardSharedViewModel) => vm.sex.name);
